const CURRENCY_TABLE = {
    'EUR': '€',
    'USD': '$',
    'GBP': '£',
};

export function getCurrencySymbol(currency: string): string {
    const symbol: string = (<any>CURRENCY_TABLE)[currency];
    if (!symbol) {
        // Fall back to the full currency name in case we don't know the symbol
        return currency;
    }
    return symbol;
}